import {
  GET_ALL_SYSTEMS_REQUEST,
  GET_ALL_SYSTEMS_SUCCESS,
  GET_ALL_SYSTEMS_FAIL,
  GET_SYSTEM_BY_NAME_REQUEST,
  GET_SYSTEM_BY_NAME_SUCCESS,
  GET_SYSTEM_BY_NAME_FAIL,
  ADD_SYSTEM_REQUEST,
  ADD_SYSTEM_SUCCESS,
  ADD_SYSTEM_FAIL
} from '../constants/SystemConstants';

const initialState = {
  responseBody: null,
  loading: false,
  msg: null,
};

export const GetAllSystems = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_SYSTEMS_REQUEST:
      return { ...state, loading: true, msg: null };

    case GET_ALL_SYSTEMS_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };

    case GET_ALL_SYSTEMS_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };

    default:
      return state;
  }
};

export const GetSystemByName = (state = initialState, action) => {
  switch (action.type) {
    case GET_SYSTEM_BY_NAME_REQUEST:
      return { ...state, loading: true, msg: null };

    case GET_SYSTEM_BY_NAME_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };

    case GET_SYSTEM_BY_NAME_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };

    default:
      return state;
  }
};

export const AddSystem = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SYSTEM_REQUEST:
      return { ...state, loading: true, msg: null };

    case ADD_SYSTEM_SUCCESS:
      return { ...state, loading: false, responseBody: action.payload, msg: null };

    case ADD_SYSTEM_FAIL:
      return { ...state, loading: false, msg: action.payload, responseBody: null };

    default:
      return state;
  }
};

// ================= SELECTOR FUNCTIONS =================
export const selectAllSystemsData = (state) => state.system?.responseBody;
export const selectAllSystemsLoading = (state) => state.system?.loading;
export const selectAllSystemsError = (state) => state.system?.msg;

export const selectAddSystemData = (state) => state.addsystem?.responseBody;
export const selectAddSystemLoading = (state) => state.addsystem?.loading;
export const selectAddSystemError = (state) => state.addsystem?.msg;

export const selectSystemByNameData = (state) => state.namesystemem?.responseBody;
export const selectSystemByNameLoading = (state) => state.namesystemem?.loading;
export const selectSystemByNameError = (state) => state.namesystemem?.msg;